import React from 'react'
import PropTypes from 'prop-types'
import { agnostifyUrl } from '../../../helpers/utils'

/**
 * M015 is the intro body copy for the top of a page.
 */
const M015 = ({ bodyCopy, textColor }) => (
  <p data-test='m015' className={`m015 text-color-${textColor}`}>
    {agnostifyUrl(bodyCopy)}
  </p>
)

M015.propTypes = {
  /** Optional body copy text */
  bodyCopy: PropTypes.string,
  /** Optional text color */
  textColor: PropTypes.string
}

M015.defaultProps = {
  bodyCopy: '',
  textColor: 'black'
}

export default M015
